import { render, staticRenderFns } from "./KnowledgeSearch.vue?vue&type=template&id=75fabede&lang=pug&"
import script from "./KnowledgeSearch.vue?vue&type=script&lang=js&"
export * from "./KnowledgeSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports